export default __webpack_public_path__ + "static/media/Profile.1a97a9fa.svg";